module.exports = __webpack_public_path__ + "static/media/Group 1579@3x.1888ebcf.png";